import React from 'react';
import './List.css';
import { FaDiamond } from "react-icons/fa6";

const PageList = ({ title, items }) => (
    <div>
        <h1 className=''>
            {title}
        </h1>
        <ul className='page-list'>
            {Array.isArray(items) && items.map((item, index) => (
                <PageListItem
                    key={index}
                    title={item?.title}
                    paragraph={item?.paragraph}
                    Icon={item?.icon}
                />
            ))}
        </ul>
    </div>
);

export default PageList;

const PageListItem = ({ title, paragraph, Icon = FaDiamond }) => (
    <li className='page-list-item'>
        <div className='page-list-icon-box'>
            {Icon && <Icon className='list-diamon-icon' />}
        </div>

        <div className='page-list-content'>
            {title && <span className='page-list-title'>{title}</span>}

            {paragraph && (
                <p
                    className='page-list-paragraph'
                    dangerouslySetInnerHTML={{ __html: paragraph }}
                ></p>
            )}
        </div>
    </li>
);


// {
//     title: "Strategic Location",
//         paragraph: "Situated between Spain and France, Andorra provides easy access to the European market.",
//     icon: TiTick,
// },
// {
//     title: "Low Taxes",
//         paragraph: "Enjoy some of Europe’s lowest corporate tax rates.",
//     icon: TiTick,
// },
// {
//     title: "Strong Legal Protection",
//         paragraph: "Comprehensive laws safeguard your assets and business operations.",
//     icon: TiTick,
// },
// {
//     title: "Business-Friendly Environment",
//         paragraph: "Minimal bureaucracy allows startups and international businesses to operate efficiently.",
//     icon: TiTick,
// }
